import { useEffect } from "react";

const GoogleAnalytics = () => {
  useEffect(() => {
    if (!window.CookieConsent) return; // Ensure Silktide is loaded

    const consentGiven = window.CookieConsent.acceptedCategory("google_analytics");

    if (consentGiven) {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-MFYDSJQ48X";
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", "G-MFYDSJQ48X");
    }
  }, []);

  return null;
};

export default GoogleAnalytics;
